import { refresher, showDialogWithData } from "../../../../redux/guest-slices/other.slice";
import { UPDATE_AVAILABILITY_SLOT } from "../../../../utils/keywords";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TimeUtils from "../../../../utils/time.utils";
import Icons from "../../../../assets/js/Icons";
import { formatPrice, getCurrencySymbol } from "../../../../utils/helper";

import {
  disableSinleSlot,
  enableSinleSlot,
  getAllAvailability,
  deleteSingleAvailability,
  updatePricing,
} from "../../../../redux/specialist-slices/availability.slice";

import {
  Box, Button, IconButton, Stack, Switch, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, TextField, Typography,
  useMediaQuery, InputAdornment
} from "@mui/material";

export const weekdays = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday",];

function Schedules() {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [pricing, setPricing] = useState(null);
  const [value, setValue] = useState("sunday");
  const { refresh } = useSelector(state => state.otherSlice);
  const { specialist } = useSelector((state) => state.authSlice);
  const { connectStatus } = useSelector((state) => state.walletSlice);
  const [durationPricing, setDurationPricing] = useState({
    30: 40,
    60: 70,
  });
  const md = useMediaQuery(({ breakpoints }) => breakpoints.down("md"));

  const handleWeekDays = (value) => { setValue(value) };

  const handleretrieveAll = async () => {
    const { data } = await dispatch(getAllAvailability(value)).unwrap() || {}
    setData(data?.slots || [])
    setPricing(data?.pricing || null);
    setDurationPricing({
      30: data?.pricing?.durationPricing?.[30] ?? 40,
      60: data?.pricing?.durationPricing?.[60] ?? 70,
    });
  };

  // const handleAddSlots = () => {
  //   dispatch(showDialogWithData({
  //     type: UPDATE_AVAILABILITY_SLOT,
  //     data: {
  //       day: value,
  //       pricing,
  //       slots: data?.map((s) => ({
  //         ...s,
  //         end: TimeUtils.formatTo24Hour(s?.end),
  //         start: TimeUtils.formatTo24Hour(s?.start),
  //       }))
  //     }
  //   }))
  // }

  const handleAddSlots = () => {
    dispatch(
      showDialogWithData({
        type: UPDATE_AVAILABILITY_SLOT,
        data: {
          day: value,
          slots: data?.map((s) => ({
            ...s,
            end: TimeUtils.formatTo24Hour(s?.end),
            start: TimeUtils.formatTo24Hour(s?.start),
          })),
        },
      })
    );
  };

  const handleUpdatePricing = async () => {
    const { success } = await dispatch(
      updatePricing({
        pricing: {
          durationPricing: {
            30: Number(durationPricing[30]),
            60: Number(durationPricing[60]),
          },
        },
      })
    ).unwrap() || {};
    if (success) {
      dispatch(refresher());
    }
  };
  const handleDelete = useCallback(async (id) => {
    const { success } = await dispatch(deleteSingleAvailability(id)).unwrap() || {}
    if (success) dispatch(refresher())
    // eslint-disable-next-line
  }, []);

  const handleToggleStatus = async (e, id) => {
    const { success } = await dispatch(
      e.target.checked ?
        enableSinleSlot(id) :
        disableSinleSlot(id)
    ).unwrap() || {}
    if (success) dispatch(refresher())
    // eslint-disable-next-line
  };

  useEffect(() => {
    handleretrieveAll()
    // eslint-disable-next-line
  }, [value, refresh])

  const isStripeConnected =
    connectStatus?.connected === true &&
    connectStatus?.chargesEnabled === true &&
    connectStatus?.payoutsEnabled === true &&
    connectStatus?.onboardingComplete === true &&
    !!connectStatus?.stripeAccountId;

  const currencySymbol = getCurrencySymbol(specialist?.profile?.currency || "USD");

  return (
    <>
      <Stack direction="row" spacing={1} mb={3} useFlexGap flexWrap="wrap">
        {weekdays?.map((ele, i) => (
          <Button
            key={i}
            size="small"
            sx={{
              minWidth: md ? 36 : 64,
              borderRadius: md ? 10 : 1,
              textTransform: "capitalize",
            }}
            onClick={() => { handleWeekDays(ele) }}
            variant={ele === value ? "contained" : "outlined"}
          >{md ? ele.charAt(0) : ele}
          </Button>
        ))
        }
      </Stack>

      <Box
        mb={3}
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "stretch", md: "flex-start" },
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Stack spacing={1.5}>
            <Stack
              direction="row"
              spacing={1.5}
              alignItems="center"
              useFlexGap
              flexWrap="wrap"
            >
              <TextField
                size="small"
                type="number"
                label="30 min price"
                value={durationPricing[30]}
                onChange={(e) =>
                  setDurationPricing((prev) => ({
                    ...prev,
                    30: e.target.value,
                  }))
                }
                sx={{
                  width: { xs: "calc(50% - 6px)", sm: "140px" },
                }}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        {currencySymbol}
                      </InputAdornment>
                    ),
                  },
                }}
              />

              <TextField
                size="small"
                type="number"
                label="60 min price"
                value={durationPricing[60]}
                onChange={(e) =>
                  setDurationPricing((prev) => ({
                    ...prev,
                    60: e.target.value,
                  }))
                }
                sx={{
                  width: { xs: "calc(50% - 6px)", sm: "140px" },
                }}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        {currencySymbol}
                      </InputAdornment>
                    ),
                  },
                }}
              />

              <Button
                size="small"
                variant="contained"
                onClick={handleUpdatePricing}
                disabled={!isStripeConnected}
                sx={{
                  height: 40,
                  whiteSpace: "nowrap",
                  width: { xs: "100%", sm: "auto" },
                }}
              >
                Update Price
              </Button>
            </Stack>

            <Typography variant="caption" color="text.secondary">
              Default fallback is{" "}
              {formatPrice(40, specialist?.profile?.currency || "USD")} for 30
              minutes and{" "}
              {formatPrice(70, specialist?.profile?.currency || "USD")} for 60
              minutes if pricing is left empty.
            </Typography>
          </Stack>
        </Box>

        <Button
          size="small"
          variant="contained"
          onClick={handleAddSlots}
          startIcon={<Icons.PlusSolid />}
          disabled={!isStripeConnected}
          sx={{
            whiteSpace: "nowrap",
            alignSelf: { xs: "stretch", sm: "flex-start" },
            height: 40,
          }}
        >Add/Edit slots
        </Button>
      </Box>

      <TableContainer variant="tableViewA">
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {["Slot time", "Availability", "Actions"]?.map((element, i) => (
                <TableCell key={i} align="left">{element}</TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {!!data?.length ?
              data?.map((element) => (
                <TableRow key={element?._id}>
                  <TableCell>
                    {`${TimeUtils.formatTo12Hour(element?.start)} — ${TimeUtils.formatTo12Hour(element?.end)}`}
                  </TableCell>
                  {/* <TableCell>0</TableCell> */}
                  <TableCell>
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={1}
                    >
                      <Typography
                        sx={{
                          width: 60,
                          textAlign: "right",
                          fontSize: 14,
                          fontWeight: 600,
                          color: !element?.isActive ? "#d32f2f" : "#9e9e9e",
                        }}
                      >
                        Inactive
                      </Typography>

                      <Switch
                        checked={element?.isActive}
                        onChange={(e) => handleToggleStatus(e, element?._id)}
                        disableRipple
                        variant="cookie"
                      />

                      <Typography
                        sx={{
                          width: 45,
                          fontSize: 14,
                          fontWeight: 600,
                          color: element?.isActive ? "#2E8DE4" : "#9e9e9e",
                        }}
                      >
                        Active
                      </Typography>
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <IconButton size="small" onClick={() => (handleDelete(element?._id))}>
                      <Icons.DeleteSolid color="error" />
                    </IconButton>
                  </TableCell>
                </TableRow>)) :
              <TableRow>
                <TableCell colSpan={3} align="center">No records found!</TableCell>
              </TableRow>
            }
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default Schedules;
